import React from 'react'

import { Switch, Router, Route } from 'wouter'

import 'App.css'
import Home from 'pages/Home'
import History from 'pages/History'
import TicketDetail from 'pages/TicketDetail'

function App () {
  return (
    <Router base={process.env.PUBLIC_URL}>
      <Switch>
        <Route path='/' component={Home} />
        <Route path='/history' component={History} />
        <Route path='/ticket/:id' component={TicketDetail} />
        <Route path='/history/:id' component={TicketDetail} />
        <Route>404, Not Found!</Route>
      </Switch>
    </Router>
  )
}

export default App
